<template>
  <section class="hero is-fullheight l-authentification">
    <div class="hero-body">
      <div
        v-if="!loading"
        class="columns is-gapless is-border has-background-white login">
        <div class="column login-cover is-7">
          <!-- :style="[illustrationStyle]" -->
        </div>
        <div class="column is-5 login-datas">
          <div class="login-datas-container">
            <form
              @submit.prevent.stop="login()"
              class="is-margin-top-auto is-margin-bottom-small login-form">
              <!-- is-margin-top-large remplacé par auto lors de la suppression du logo-->
              <div v-if="showOtpInput">
                <div class="column is-borderless is-shadowless">
                  <div class="has-text-centered is-margin-top-auto">
                    <router-link :to="{name: 'Login'}">
                      <img
                        src="/img/vadimm/cadenas-illustration.svg"
                        class="image is-margin-left-auto is-margin-right-auto"
                        width="200"
                        alt="Vadimm">
                    </router-link>
                  </div>
                  <header class="is-shadowless is-margin-top">
                    <h1
                      class="card-header-title is-size-2 is-padding-left-small"
                      v-html="'Saisissez le<br>code reçu par sms'"></h1>
                  </header>
                  <p class="is-size-6">
                    Nous avons envoyé un code par SMS sur votre numéro de téléphone. <br>
                  </p>
                  <input
                    v-model="otpCode"
                    type="text"
                    class="input"
                    placeholder="Code OTP" />
                  <button
                    type="submit"
                    class="button is-login is-fullwidth is-radiusless is-margin-top-small"
                    @click="verifyOtpLogin">
                    Valider
                  </button>
                </div>
              </div>
              <div v-else>
                <div class="is-margin-bottom-large">
                  <div class="title is-3">
                    Connectez-vous à votre compte
                  </div>
                </div>
                <v-input
                  :name="'email'"
                  :classes-input="'is-fullwidth'"
                  @input="val =>email = val"
                  :model="email"
                  :placeholder="'VOTRE EMAIL'"
                  v-validate="'required|email'"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  data-vv-as="Email"
                  data-type-cy="input"
                  data-value-cy="login_email"
                  autocomplete="email"
                  class="field">
                </v-input>

                <v-input-password
                  :name="'password'"
                  :classes-input="'is-fullwidth'"
                  @input="val =>password = val"
                  :model="password"
                  :display-password.sync="displayPassword"
                  :placeholder="'VOTRE MOT DE PASSE'"
                  v-validate="'required|min:6'"
                  autocomplete="current-password"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  data-vv-as="Password"
                  data-type-cy="input"
                  data-value-cy="login_password"></v-input-password>
                <div
                  ref="recaptchaWrapper"
                  class="recaptcha-wrapper">
                  <div
                    id="recaptcha-container"
                    class="g-recaptcha"
                    data-callback="onCaptchaVerified"
                    data-expired-callback="onCaptchaExpired">
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <button
                      type="submit"
                      class="button is-login is-fullwidth is-radiusless is-margin-top-small"
                      id="loginSubmit"
                      :disabled="!canSubmit || loading"
                      :class="{'is-loading':loading}"
                      data-type-cy="button"
                      data-value-cy="login_submit">
                      <span
                        v-if="!loading"
                        class="is-uppercase is-size-6 has-text-weight-mediums">Connectez-vous</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <div class="control">
              <div
                v-if="!showOtpInput"
                class="is-clearfix">
                <p class="is-size-6 has-text-grey has-text-weight-medium">
                  Problème de connexion -
                  <router-link
                    :to="{name: 'ResetPassword'}"
                    data-type-cy="link"
                    data-value-cy="reset_password"
                    class="has-text-login is-underline">
                    Cliquez ici
                  </router-link>
                </p>
              </div>
              <div
                v-else
                class="is-clearfix">
                <p class="is-size-6 has-text-grey has-text-weight-medium">
                  Demander un autre code -
                  <button
                    @click="verifyOtpLogin()"
                    data-type-cy="link"
                    data-value-cy="reset_password"
                    class="has-text-login is-underline">
                    Cliquez ici
                  </button>
                </p>
              </div>
            </div>
            <hr>
            <div class="has-text-centered is-margin-top-xxsmall">
              <p class="is-size-6 has-text-grey has-text-weight-medium">
                <button
                  class="social-btn microsoft is-login is-fullwidth is-radiusless"
                  @click="openMicrosoftPopup">
                  <div class="icon-wrapper">
                    <i class="fab fa-windows"></i>
                  </div>
                  <span>CONNEXION MICROSOFT</span>
                </button>
              </p>
            </div>
            <div class="has-text-centered is-margin-top-xxsmall">
              <p class="is-size-6 has-text-grey has-text-weight-medium">
                <button
                  class="social-btn google is-login is-fullwidth is-radiusless"
                  @click="openGooglePopup">
                  <div class="icon-wrapper">
                    <i class="fab fa-google"></i>
                  </div>
                  <span>CONNEXION GOOGLE</span>
                </button>
              </p>
            </div>
            <div class="is-clearfix is-margin-top-xsmall">
              <p class="is-size-7 has-text-grey has-text-weight-medium is-italic">
                Disponible sur les comptes autorisés
              </p>
            </div>
            <div class="is-margin-top-auto">
              <div class="columns is-gapless is-align-items-flex-end">
                <div class="column is-narrow">
                  <img
                    src="/img/vadimm/vadimm-logo--multicolor.svg"
                    width="24"
                    alt="">
                </div>
                <div class="column is-margin-bottom-xsmall">
                  <p class="has-text-right has-text-grey is-size-7">
                    <small>Vadimm V. {{ appVersion }}</small>
                  </p>
                </div>
              </div>
            </div>
          </div><!-- .login-datas-container -->
        </div><!-- .login-datas -->
      </div><!-- .login -->
    </div>
  </section>
</template>

<script>
import { isNil } from 'lodash'
import { mapGetters } from 'vuex'
import { bus, EVENTS } from '@/bus'
import jwtDecode from 'jwt-decode'
import { AnalyticEvent, logAnalyticEvent } from '../../firebaseApp'

export default {
  name: 'AppLogin',
  data () {
    return {
      email: '',
      password: '',
      loading: false,
      displayPassword: false,
      captchaToken: null,
      tokenStatApi: null,
      otpCode: null,
      showOtpInput: false,
      from: null,
      token: false,
      currentUser: null,
      widget: null
    }
  },
  computed: {
    ...mapGetters(['isLog', 'isAdmin', 'isPromoteur']),
    appVersion () {
      return process.env.npm_package_version
    },
    canSubmit () {
      return this.errors.any() === false && isNil(this.password) === false && isNil(this.email) === false && isNil(this.captchaToken) === false
    },
    illustrationStyle () {
      let styleObject = {}
      if (this.$configs && this.$configs.ILLUSTRATION_LOGIN && this.$configs.ILLUSTRATION_LOGIN !== '') {
        styleObject.backgroundImage = 'url(\' ' + this.$configs.ILLUSTRATION_LOGIN + ' \')'
      } else {
        styleObject.backgroundImage = 'url(\'/img/vadimm/login-illustration-min.jpg\')'
      }
      return styleObject
    },
    captchaReady () {
      return this.captchaToken
    }
  },
  created () {
    if (this.$route.query.token && this.$route.query.email) {
      this.$router.push({
        name: 'ResetPassword',
        query: { token: this.$route.query.token, email: this.$route.query.email }
      })
    }
    if (this.$route.query.email) {
      this.email = this.$route.query.email
    }
  },
  mounted () {
    if (window.grecaptcha) {
      this.renderRecaptcha()
    } else {
      window.onloadCallback = this.renderRecaptcha
    }
    const vm = this
    window.onCaptchaVerified = function (token) {
      vm.captchaToken = token
    }

    window.onCaptchaExpired = function () {
      vm.captchaToken = null
    }
    this.resizeRecaptcha()
    window.addEventListener('pageshow', this.renderRecaptcha)
    window.addEventListener('resize', this.resizeRecaptcha)

    if (this.isLog && !this.jwtExpired(localStorage.getItem('token'))) {
      this.$toasted.global.danger('Vous êtes déjà connecté.')
      this.$router.replace({ name: 'Home' })
    }
  },
  beforeDestroy () {
    window.addEventListener('pageshow', this.renderRecaptcha)
    window.removeEventListener('resize', this.resizeRecaptcha)
  },
  methods: {
    renderRecaptcha () {
      if (!window.grecaptcha || !window.grecaptcha.render) {
        setTimeout(this.renderRecaptcha, 100)
        return
      }
      this.widget = window.grecaptcha.render('recaptcha-container', {
        sitekey: this.$configs.SITE_KEY,
        theme: 'light',
        'expired-callback': window.onCaptchaExpired
      })
    },
    async login () {
      const payload = {
        email: this.email,
        password: this.password,
        captcha: this.captchaToken
      }
      try {
        const { data } = await this.$api.post(this.$resources.LOGIN, payload)
        this.token = data.access_token
        localStorage.setItem('token', this.token)
        this.from = localStorage.getItem('redirectAfterLogin')
        this.from = JSON.parse(this.from)
        this.currentUser = jwtDecode(this.token)
        if (this.currentUser.profil && this.currentUser.profil !== 'seller') {
          try {
            const response = await this.$statsApiAuth.post('/auth', {
              'user_pk': this.currentUser.pk,
              'access_key': this.$configs.ACCESS_KEY
            })
            this.tokenStatApi = response.data.access_token
            localStorage.setItem('tokenStatApi', this.tokenStatApi)
          } catch (error) {
            console.log('Error catch stats auth ==>', error)
          }
        }
        // if (this.currentUser.account_type !== 'promoteur') {
        //   this.showOtpInput = true
        // } else {
        if (this.from) {
          this.$router.push(this.from)
        } else {
          if (this.currentUser && this.currentUser.profil === 'admin' && this.currentUser.account_type === 'promoteur') {
            this.$router.push({ name: 'Dashboard' })
              .catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                  throw err
                }
                console.log('Navigation dupliquée détectée.')
              })
          } else {
            this.$router.push({ name: 'ProgramCardList' })
              .catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                  throw err
                }
                console.log('Navigation dupliquée détectée.')
              })
          }
        }
        localStorage.removeItem('redirectAfterLogin')
        bus.$emit(EVENTS.LOGIN, this.token, this.tokenStatApi)
        logAnalyticEvent(AnalyticEvent.LOGIN)
        // }
      } catch (e) {
        window.grecaptcha.reset(this.widget)
        if (e.response.status === 429) {
          this.$toasted.global.danger('Trop de tentatives veuillez réessayer plus tard !')
        } else if (e.response.data.message === 'AuthSsoExcepted') {
          this.openMicrosoftPopup()
        } else {
          this.$toasted.global.danger('Erreur de connexion !')
        }
      }
    },
    jwtExpired (jwt) {
      const decoded = jwtDecode(jwt)
      if (!decoded) {
        return true
      }
      let expired = false
      if (!decoded) {
        expired = true
      } else {
        expired = decoded.exp < Date.now() / 1000
      }
      return expired
    },
    validate (cb) {
      this.$validator.validateAll().then((result) => {
        cb(result)
      })
    },
    openMicrosoftPopup () {
      window.addEventListener('message', this.handleSocialLogin, false)
      const width = 600
      const height = 700
      const left = (window.innerWidth - width) / 2
      const top = (window.innerHeight - height) / 2

      window.open(
        this.$configs.APIROOT + '/microsoft-auth/login',
        'MicrosoftLogin',
        `width=${width},height=${height},top=${top},left=${left}`
      )
    },
    resizeRecaptcha () {
      const wrapper = this.$refs.recaptchaWrapper
      if (!wrapper) return

      const recaptcha = wrapper.querySelector('.g-recaptcha')
      if (!recaptcha) return

      const containerWidth = wrapper.offsetWidth
      const reCaptchaWidth = 304
      const reCaptchaHeight = 78

      const scale = containerWidth / reCaptchaWidth

      recaptcha.style.transform = `scale(${scale})`
      recaptcha.style.transformOrigin = '0 0'
      wrapper.style.height = `${reCaptchaHeight * scale}px`
    },
    setLogoutTimer (logoutTimeInMinutes) {
      localStorage.setItem('logoutTime', logoutTimeInMinutes)
      localStorage.setItem('lastActivityTime', Date.now())
    },
    openGooglePopup () {
      window.addEventListener('message', this.handleSocialLogin, false)
      const width = 600
      const height = 700
      const left = (window.innerWidth - width) / 2
      const top = (window.innerHeight - height) / 2

      window.open(
        this.$configs.APIROOT + '/google-auth/login',
        'GoogleLogin',
        `width=${width},height=${height},top=${top},left=${left}`
      )
    },
    async handleSocialLogin (event) {
      window.removeEventListener('message', this.handleSocialLogin, false)
      if (event.data.error === 'user_not_found') {
        this.$toasted.global.danger('Erreur de connexion microsoft !')
        this.$router.push({ name: 'Login' })
        return
      }

      const token = event.data.token
      const user = event.data.user
      const expiration = event.data.expires_in
      this.setLogoutTimer(expiration)

      localStorage.setItem('token', token)

      const currentUser = user
      if (currentUser.profil && currentUser.profil !== 'seller') {
        try {
          const response = await this.$statsApiAuth.post('/auth', {
            user_pk: currentUser.pk,
            access_key: this.$configs.ACCESS_KEY
          })
          this.tokenStatApi = response.data.access_token
          localStorage.setItem('tokenStatApi', this.tokenStatApi)
        } catch (error) {
          console.log('Error catch stats auth ==>', error)
        }
      }

      const from = JSON.parse(localStorage.getItem('redirectAfterLogin'))

      if (from) {
        this.$router.push(from)
      } else if (currentUser.profil === 'admin') {
        this.$router.push({ name: 'Dashboard' })
      } else {
        this.$router.push({ name: 'ProgramCardList' })
      }

      localStorage.removeItem('redirectAfterLogin')
      bus.$emit(EVENTS.LOGIN, token, this.tokenStatApi)
    },
    async verifyOtpLogin () {
      const payload = {
        user: this.currentUser,
        code: this.otpCode
      }
      try {
        await this.$api.axios.post('/verify-otp', payload)
        if (this.from) {
          this.$router.push(this.from)
        } else {
          if (this.currentUser && this.currentUser.profil === 'admin' && this.currentUser.account_type === 'promoteur') {
            this.$router.push({ name: 'Dashboard' })
              .catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                  throw err
                }
                console.log('Navigation dupliquée détectée.')
              })
          } else {
            this.$router.push({ name: 'ProgramCardList' })
              .catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                  throw err
                }
                console.log('Navigation dupliquée détectée.')
              })
          }
        }
        localStorage.removeItem('redirectAfterLogin')
        bus.$emit(EVENTS.LOGIN, this.token, this.tokenStatApi)
        logAnalyticEvent(AnalyticEvent.LOGIN)
      } catch (e) {
        if (e.response.status === 429) {
          this.$toasted.global.danger('Trop de tentatives veuillez réessayer plus tard !')
        } else {
          this.$toasted.global.danger('Erreur de connexion !')
        }
      }
    }
  }
}
</script>

<style lang="sass">
hr
  margin: 20px 0
  border: none
  border-top: 1px solid #ccc

.social-btn
  position: relative
  width: 100%
  height: 50px
  border: none
  color: white
  font-weight: 400
  font-size: 14px
  cursor: pointer

  display: flex
  align-items: center
  justify-content: center

.social-btn .icon-wrapper
  position: absolute
  left: 20px
  top: 50%
  font-size: 20px
  transform: translateY(-50%)

/* styles spécifiques */
.social-btn.google
  background: linear-gradient(90deg, #2f80ed, #2d9cdb)

.social-btn.microsoft
  background: #155e8a

</style>
